const ANSWER_EIGHT =
  '¿Tuvo compras y consumos totales superiores a $65.891.000 (equivalentes a 1.400 UVT) durante el año inmediatamente anterior?';

export { ANSWER_EIGHT };
